import { GiveawayStep } from '../../constants/giveaway.constants';
export const isGiveawayStepPassed = (passedSteps, step) => {
  const lookupStep = step === GiveawayStep.selectLast ? GiveawayStep.customize : step;
  return passedSteps.includes(lookupStep);
};